import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Sparkles, Trophy, Award } from "lucide-react";

function photo(url) {
  if (!url) return null;
  if (url.startsWith("http")) return url;
  return `${API.replace(/\/api$/, "")}${url}`;
}

export default function FeaturedWeekCard() {
  const [champ, setChamp] = useState(null);
  const [ref, setRef] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get("/contributor/top-contributors", { params: { limit: 1 } }).then((r) => setChamp(r.data?.[0])).catch(() => {}),
      api.get("/contributor/leaderboard", { params: { limit: 1 } }).then((r) => setRef(r.data?.[0])).catch(() => {}),
    ]);
  }, []);

  if (!champ && !ref) return null;

  return (
    <section className="mb-8 relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#7C2D12] via-[#B45309] to-[#EA580C] p-6 md:p-7 shadow-2xl border border-amber-300/40" data-testid="featured-week">
      <div className="absolute -top-6 -right-6 text-amber-300/10 text-[220px] font-devnagri-heading font-black leading-none pointer-events-none select-none">21</div>
      <div className="absolute top-3 right-4 opacity-40">
        <Sparkles className="w-24 h-24 text-amber-200"/>
      </div>
      <div className="relative flex items-center gap-2 mb-4">
        <Sparkles className="w-4 h-4 text-amber-200"/>
        <div className="uppercase tracking-[0.28em] text-[10px] font-black text-amber-100">इस हफ़्ते के गौरव पाठक</div>
      </div>
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-5">
        {champ && (
          <div className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/20 flex items-center gap-4" data-testid="fw-champ">
            <div className="relative shrink-0">
              {champ.photo_url ? (
                <img src={photo(champ.photo_url)} alt="" className="w-16 h-16 rounded-full object-cover border-2 border-amber-200 shadow-lg"/>
              ) : (
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-300 to-orange-400 text-white flex items-center justify-center font-black text-xl shadow-lg border-2 border-amber-200">
                  {champ.name?.[0] || "?"}
                </div>
              )}
              <div className="absolute -bottom-1 -right-1 bg-amber-400 text-[#0F172A] rounded-full p-1 shadow">
                <Trophy className="w-3 h-3"/>
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <div className="uppercase tracking-widest text-[9px] font-black text-amber-200">शीर्ष योगदानकर्ता</div>
              <div className="font-devnagri-heading text-xl font-black text-white leading-tight truncate">{champ.name}</div>
              <div className="text-[11px] text-amber-100/90 mt-0.5 truncate">
                {champ.city ? `📍 ${champ.city} · ` : ""}<b>{champ.count} रिपोर्ट{champ.count > 1 ? "ें" : ""}</b> प्रकाशित
              </div>
            </div>
          </div>
        )}
        {ref && (
          <div className="bg-white/10 backdrop-blur rounded-xl p-4 border border-white/20 flex items-center gap-4" data-testid="fw-ref">
            <div className="relative shrink-0">
              {ref.photo_url ? (
                <img src={photo(ref.photo_url)} alt="" className="w-16 h-16 rounded-full object-cover border-2 border-emerald-200 shadow-lg"/>
              ) : (
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-300 to-teal-400 text-white flex items-center justify-center font-black text-xl shadow-lg border-2 border-emerald-200">
                  {ref.name?.[0] || "?"}
                </div>
              )}
              <div className="absolute -bottom-1 -right-1 bg-emerald-400 text-[#0F172A] rounded-full p-1 shadow">
                <Award className="w-3 h-3"/>
              </div>
            </div>
            <div className="min-w-0 flex-1">
              <div className="uppercase tracking-widest text-[9px] font-black text-emerald-100">टॉप रेफरर · गौरव पाठक</div>
              <div className="font-devnagri-heading text-xl font-black text-white leading-tight truncate">{ref.name}</div>
              <div className="text-[11px] text-emerald-100/90 mt-0.5 truncate">
                {ref.city ? `📍 ${ref.city} · ` : ""}<b>+{ref.referred} दोस्त</b> जोड़े
              </div>
            </div>
          </div>
        )}
      </div>
      <p className="relative mt-4 text-[11px] text-amber-100/80 leading-relaxed">
        🎉 हर हफ़्ते सबसे ज़्यादा योगदान और रेफरल देने वालों को यहाँ प्रधान संपादक <b className="text-amber-200">JAKIR MOMIN</b> सर सम्मानित करेंगे।
      </p>
    </section>
  );
}
